import { SkeletonCard } from '@optimus-web/core';
import { AssistantSmartTipsEntity } from '@mews-commander/data-access';
import { lt } from '@mews/framework';
import { SmartTip } from '@mews/b2b-ui';
import { useAssistantSmartTipsQuery } from '../query/useAssistantSmartTipsQuery';

interface SmartTipsProps {
    itemId: string;
    chainId: string;
    entity: AssistantSmartTipsEntity;
    enterpriseIds: Array<string>;
}

export const SmartTips = ({ itemId, chainId, entity, enterpriseIds }: SmartTipsProps) => {
    const { data, isFetching, error } = useAssistantSmartTipsQuery({
        id: itemId,
        chainId,
        entity,
        enterpriseIds,
    });

    return (
        <>
            {!isFetching && data ? (
                <SmartTip
                    label={data.tips ? lt('AssistantSmartTipsTitle') : lt('AssistantSmartTipsNotAvailableTitle')}
                    disclaimer={data.tips ? lt('AssistantSmartTipsDisclaimer') : null}
                    textMoreButton={lt('MoreInfo')}
                    textLessButton={lt('LessInfo')}
                >
                    {error
                        ? lt('AssistantSmartTipsErrorMessage')
                        : data?.tips || lt('AssistantSmartTipsNotAvailableBody')}
                </SmartTip>
            ) : (
                <SkeletonCard width="100%" height="150px" />
            )}
        </>
    );
};
